import { useState } from 'react';
import styles from './EmergencyHotlinePanel.module.css';

const PHONE_RE = /^01[016789][-\s]?\d{3,4}[-\s]?\d{4}$/;

/**
 * 응급 분류 시 노출 — 휴대폰 번호 + 사건 한 줄 수집 (기획 03 §7.2 + 02 §6.3).
 * 카운트는 차감되지 않고 콜백 큐에 적재됨.
 */
export function EmergencyHotlinePanel({ onSubmit, submitting }) {
  const [phone, setPhone] = useState('');
  const [summary, setSummary] = useState('');
  const phoneValid = PHONE_RE.test(phone.trim());

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!phoneValid || submitting) return;
    onSubmit(phone.trim(), summary.trim() || null);
  };

  return (
    <form className={styles.panel} onSubmit={handleSubmit} aria-label="응급 핫라인 콜백 신청">
      <div className={styles.heading}>
        <span className={styles.dot} aria-hidden="true" />
        응급 사안 — 변호사 즉시 콜백
      </div>
      <p className={styles.note}>
        분류된 응급 사안입니다. 휴대폰 번호를 남겨주시면 당직 변호사가 즉시 연락드립니다.
      </p>

      <label className={styles.field}>
        <span className={styles.fieldLabel}>휴대폰</span>
        <input
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          placeholder="010-1234-5678"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className={styles.input}
          required
          aria-invalid={phone.length > 0 && !phoneValid}
        />
      </label>

      <label className={styles.field}>
        <span className={styles.fieldLabel}>사건 한 줄 (선택)</span>
        <input
          type="text"
          maxLength={200}
          placeholder="예: 보호자가 응급실에서 진료기록 즉시 제출 요구 중"
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          className={styles.input}
        />
      </label>

      <button type="submit" disabled={!phoneValid || submitting} className={styles.submit}>
        {submitting ? '신청 중…' : '핫라인 콜백 신청'}
      </button>
    </form>
  );
}
